<template lang="pug">
  div.e-steps
    el-steps(
      v-if="steps && steps.length > 0"
      :active="activeIndex"
    )
      el-step(
        v-for="step, stepIndex in steps"
        :key="stepIndex"
        :title="step.name"
      )
</template>

<script>
  export default {
    name: 'e-steps',
    props: {
      steps: {
        type: Array,
        default: function () {
          return []
        }
      },
      activeIndex: {
        type: Number,
        default: 0
      }
    }
  }
</script>
